import React from "react";
import PropTypes from "prop-types";

import useMousePosition from "./use-mouse-position";

const CustomCursor = (props) => {
  // 1.
  const { x, y } = useMousePosition();
  return (
    <div className="custom-cursor">
      {props.playing ? (
        <img
          className="pause"
          src="/tas-stop.svg"
          alt="stop"
          style={{ left: `${x}px`, top: `${y}px` }}
        />
      ) : (
        <img
          className="play"
          src="/tas-zuhoeren.svg"
          alt="listen"
          style={{ left: `${x}px`, top: `${y}px` }}
        />
      )}
    </div>
  );
};

CustomCursor.propTypes = {
  playing: PropTypes.bool,
};

export default CustomCursor;
